._59utm10 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
._59utm11 {
  text-align: center;
  margin-bottom: 16px;
}
._59utm12 {
  margin: 0 0 8 0;
  font-size: 20px;
  font-weight: 600;
}
._59utm13 {
  color: var(--_1qu8za24);
  margin: 0;
}
._59utm14 {
  display: flex;
  gap: 12px;
}
._59utm15 {
  flex: 1;
}